<template>
  <div>
    <v-container>
      <v-row>
        <h2 class="pb-2 pt-2">Admin — Batch-Jobs</h2>
      </v-row>
      <v-row>
        <v-col cols="12" md="6" v-for="job in jobs" :key="job.key">
          <v-card>
            <v-card-title>{{ job.label }}</v-card-title>
            <v-card-text>
              <v-text-field v-model="job.from" label="Von" type="date" density="compact" hide-details class="mb-2"/>
              <v-text-field v-model="job.to" label="Bis" type="date" density="compact" hide-details class="mb-3"/>
              <v-btn :loading="job.running" :disabled="!job.from || !job.to || job.running" color="primary" @click="run(job)">
                Ausführen
              </v-btn>
              <div v-if="job.running" class="mt-3 text-medium-emphasis">{{ job.done }} / {{ job.total }} …</div>
              <div v-if="job.summary" class="mt-3">{{ job.summary }}</div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <small class="text-medium-emphasis">
            Jobs laufen asynchron; Ergebnisse erscheinen nach kurzer Zeit.
          </small>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { DateTime } from 'luxon'
import TitleMixin from '@/mixins/TitleMixin'

export default {
  name: 'Admin',

  mixins: [TitleMixin],

  data() {
    return {
      title: `Admin - ${import.meta.env.VITE_NAME}`,
      jobs: [
        { key: 'route-delta', label: 'Routen-Delta Vorberechnung', path: '/admin/route-delta',
          from: null, to: null, running: false, done: 0, total: 0, summary: null },
        { key: 'stats', label: 'Statistik Vorberechnung', path: '/admin/stats',
          from: null, to: null, running: false, done: 0, total: 0, summary: null },
      ],
    };
  },

  methods: {
    datesInRange(from, to) {
      const start = DateTime.fromISO(from);
      const end = DateTime.fromISO(to);
      const days = [];
      for (let day = start; day <= end; day = day.plus({ days: 1 })) {
        days.push(day.toISODate());
      }
      return days;
    },

    async run(job) {
      const days = this.datesInRange(job.from, job.to);
      if (!days.length) {
        job.summary = 'Ungültiger Zeitraum.';
        return;
      }
      job.running = true;
      job.summary = null;
      job.done = 0;
      job.total = days.length;
      let failures = 0;
      for (const day of days) {
        try {
          await this.$api.get(`${job.path}?date=${day}`);
        } catch (err) {
          failures += 1;
          this.$log.error(err);
        }
        job.done += 1;
      }
      job.running = false;
      job.summary = `${job.total - failures} Tag(e) angestoßen, ${failures} Fehler.`;
    },
  },
};
</script>
